var _style, _g, _g2, _path, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSjaelvtestDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Lager_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180.6 53.4",
    style: {
      enableBackground: "new 0 0 180.6 53.4",
      background: "transparent"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#fff;}\r\n\t.st2{fill:none;stroke:url(#SVGID_1_);stroke-width:6.7742;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st3{fill:#1E1E1C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.9,47.8c-5.5-0.1-10.7-2.3-14.6-6.2c-3.9-4-6-9.2-5.9-14.8c0.1-11.3,9.4-20.6,20.8-20.6l0.2,0   c5.5,0.1,10.7,2.3,14.6,6.2c3.9,4,6,9.2,5.9,14.8c-0.1,11.3-9.4,20.6-20.8,20.6L31.9,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1,5.7v1l0.2,0c5.4,0.1,10.5,2.2,14.3,6.1c3.8,3.9,5.8,9,5.8,14.4c-0.1,11.1-9.2,20.1-20.3,20.1l-0.2,0   c-5.4-0.1-10.5-2.2-14.3-6.1c-3.8-3.9-5.8-9-5.8-14.4c0.1-11.1,9.2-20.1,20.3-20.1L32.1,5.7 M32.1,5.7c-11.6,0-21.1,9.4-21.3,21   c-0.1,11.7,9.3,21.4,21,21.5c0.1,0,0.1,0,0.2,0c11.6,0,21.1-9.4,21.3-21c0.1-11.7-9.3-21.4-21-21.5C32.3,5.7,32.2,5.7,32.1,5.7   L32.1,5.7z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.3904,
    y1: -303.2077,
    x2: 50.6043,
    y2: -303.2077,
    gradientTransform: "matrix(-1 0 0 -1 64.0005 -283.5365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E41913"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0974402,
    style: {
      stopColor: "#EA6516"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2148,
    style: {
      stopColor: "#F3A518"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3121,
    style: {
      stopColor: "#F9CD1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    style: {
      stopColor: "#FDE31A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    style: {
      stopColor: "#FEEB1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6231,
    style: {
      stopColor: "#DFDE20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.2,26.7c-2.2-18.6-27.8-19-30.4,0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.7,27.3l8.8-15.8l-1.8,18c-0.6,1.9-2.7,3-4.6,2.4S27.1,29.2,27.7,27.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5,30.5c0,0.7-0.2,1.4-0.5,2s-0.8,1.2-1.4,1.7c-0.6,0.5-1.4,0.9-2.2,1.2c-0.8,0.3-1.9,0.4-3.1,0.4    c-1.3,0-2.4-0.1-3.4-0.4c-1-0.2-2.1-0.6-3.1-1.1v-3H63c0.9,0.7,1.9,1.3,3.1,1.7c1.2,0.4,2.3,0.6,3.3,0.6c1.5,0,2.6-0.3,3.4-0.8    c0.8-0.5,1.2-1.3,1.2-2.2c0-0.8-0.2-1.4-0.6-1.7s-1-0.7-1.8-0.9c-0.6-0.2-1.2-0.3-1.9-0.4c-0.7-0.1-1.4-0.2-2.2-0.4    c-1.6-0.3-2.7-0.9-3.5-1.7c-0.8-0.8-1.1-1.9-1.1-3.1c0-1.5,0.6-2.7,1.9-3.6c1.3-0.9,2.8-1.4,4.8-1.4c1.2,0,2.4,0.1,3.4,0.4    c1,0.2,2,0.5,2.8,0.9v2.8h-0.2c-0.7-0.6-1.6-1-2.7-1.4c-1.1-0.4-2.2-0.6-3.4-0.6c-1.3,0-2.3,0.3-3,0.8c-0.8,0.5-1.1,1.2-1.1,2    c0,0.7,0.2,1.3,0.6,1.7c0.4,0.4,1.1,0.7,2,1c0.5,0.1,1.2,0.2,2.2,0.4c0.9,0.2,1.7,0.3,2.4,0.5c1.3,0.3,2.3,0.9,3,1.6    C76.1,28.3,76.5,29.3,76.5,30.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.3,35.9c0,1.6-0.4,2.7-1.2,3.5s-1.9,1.2-3.2,1.2c-0.3,0-0.7,0-1.3-0.1c-0.5-0.1-1-0.1-1.3-0.2v-2.1h0.1    c0.2,0.1,0.5,0.2,0.9,0.3c0.4,0.1,0.7,0.2,1.1,0.2c0.6,0,1-0.1,1.4-0.2c0.3-0.2,0.6-0.4,0.8-0.7c0.2-0.3,0.3-0.7,0.3-1.1    c0.1-0.4,0.1-1,0.1-1.6V24.2h-2.8v-1.9h5V35.9z M84.5,20.1h-2.5v-2.3h2.5V20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.3,35.6H97v-1.4c-0.2,0.1-0.5,0.3-0.8,0.6s-0.7,0.4-1,0.6c-0.4,0.2-0.8,0.3-1.3,0.5    c-0.5,0.1-1.1,0.2-1.7,0.2c-1.2,0-2.2-0.4-3-1.2C88.4,34,88,33,88,31.7c0-1,0.2-1.8,0.6-2.4c0.4-0.6,1-1.1,1.8-1.5    c0.8-0.4,1.8-0.6,2.9-0.7c1.1-0.1,2.4-0.2,3.7-0.3v-0.3c0-0.5-0.1-0.9-0.3-1.3s-0.4-0.6-0.8-0.8c-0.3-0.2-0.7-0.3-1.1-0.4    c-0.4-0.1-0.9-0.1-1.4-0.1c-0.6,0-1.2,0.1-2,0.2c-0.7,0.2-1.5,0.4-2.2,0.7h-0.1v-2.3c0.4-0.1,1.1-0.3,1.9-0.4    c0.8-0.1,1.6-0.2,2.4-0.2c0.9,0,1.8,0.1,2.4,0.2c0.7,0.2,1.3,0.4,1.8,0.8c0.5,0.4,0.9,0.8,1.1,1.4s0.4,1.3,0.4,2.2V35.6z M97,32.3    v-3.7c-0.7,0-1.5,0.1-2.4,0.2S93,29,92.4,29.1c-0.6,0.2-1.2,0.5-1.6,0.9c-0.4,0.4-0.6,0.9-0.6,1.6c0,0.8,0.2,1.3,0.7,1.7    c0.5,0.4,1.2,0.6,2.1,0.6c0.8,0,1.5-0.2,2.2-0.5C95.9,33.1,96.5,32.7,97,32.3z M92.8,20.1h-2.4v-2.3h2.4V20.1z M97.8,20.1h-2.4    v-2.3h2.4V20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.1,35.6h-2.2V17.1h2.2V35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.2,22.3l-5.4,13.3h-2.2l-5.3-13.3h2.4l4.1,10.6l4.1-10.6H122.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.3,35.5c-0.4,0.1-0.9,0.2-1.4,0.3c-0.5,0.1-0.9,0.1-1.3,0.1c-1.4,0-2.4-0.4-3.1-1.1    c-0.7-0.7-1.1-1.9-1.1-3.5v-7.1h-1.5v-1.9h1.5v-3.8h2.2v3.8h4.6v1.9h-4.6v6.1c0,0.7,0,1.2,0,1.6c0,0.4,0.1,0.8,0.3,1.1    c0.2,0.3,0.4,0.5,0.7,0.7c0.3,0.1,0.8,0.2,1.4,0.2c0.4,0,0.7-0.1,1.1-0.2c0.4-0.1,0.7-0.2,0.9-0.3h0.1V35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.4,29.2h-9.8c0,0.8,0.1,1.5,0.4,2.1c0.2,0.6,0.6,1.1,1,1.5c0.4,0.4,0.9,0.7,1.5,0.9    c0.6,0.2,1.2,0.3,1.9,0.3c0.9,0,1.8-0.2,2.7-0.5c0.9-0.4,1.6-0.7,2-1.1h0.1v2.4c-0.8,0.3-1.5,0.6-2.3,0.8s-1.6,0.3-2.5,0.3    c-2.2,0-3.9-0.6-5.2-1.8c-1.2-1.2-1.9-2.9-1.9-5.1c0-2.2,0.6-3.9,1.8-5.2c1.2-1.3,2.7-1.9,4.7-1.9c1.8,0,3.2,0.5,4.1,1.6    c1,1,1.5,2.5,1.5,4.5V29.2z M144.2,27.5c0-1.2-0.3-2.1-0.9-2.7s-1.5-1-2.7-1c-1.2,0-2.2,0.4-2.9,1.1c-0.7,0.7-1.1,1.6-1.2,2.6    H144.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.5,31.7c0,1.2-0.5,2.2-1.5,3s-2.4,1.2-4.1,1.2c-1,0-1.9-0.1-2.7-0.4c-0.8-0.2-1.5-0.5-2.1-0.8v-2.5h0.1    c0.7,0.5,1.5,1,2.4,1.3s1.7,0.5,2.5,0.5c1,0,1.8-0.2,2.3-0.5c0.6-0.3,0.8-0.8,0.8-1.5c0-0.5-0.2-0.9-0.5-1.2s-0.9-0.5-1.7-0.7    c-0.3-0.1-0.7-0.2-1.2-0.3c-0.5-0.1-1-0.2-1.4-0.3c-1.2-0.3-2-0.8-2.5-1.4c-0.5-0.6-0.7-1.3-0.7-2.2c0-0.5,0.1-1.1,0.3-1.5    c0.2-0.5,0.6-0.9,1-1.3c0.4-0.4,1-0.7,1.7-0.9c0.7-0.2,1.5-0.3,2.3-0.3c0.8,0,1.6,0.1,2.4,0.3c0.8,0.2,1.5,0.4,2,0.7v2.4h-0.1    c-0.6-0.4-1.3-0.8-2.1-1.1c-0.8-0.3-1.6-0.4-2.4-0.4c-0.8,0-1.5,0.2-2.1,0.5c-0.6,0.3-0.8,0.8-0.8,1.4c0,0.5,0.2,1,0.5,1.2    c0.3,0.3,0.9,0.5,1.6,0.7c0.4,0.1,0.9,0.2,1.4,0.3c0.5,0.1,0.9,0.2,1.3,0.3c1,0.2,1.8,0.6,2.4,1.2C159.2,30,159.5,30.8,159.5,31.7    z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.9,35.5c-0.4,0.1-0.9,0.2-1.4,0.3c-0.5,0.1-0.9,0.1-1.3,0.1c-1.4,0-2.4-0.4-3.1-1.1    c-0.7-0.7-1.1-1.9-1.1-3.5v-7.1h-1.5v-1.9h1.5v-3.8h2.2v3.8h4.6v1.9h-4.6v6.1c0,0.7,0,1.2,0,1.6c0,0.4,0.1,0.8,0.3,1.1    c0.2,0.3,0.4,0.5,0.7,0.7c0.3,0.1,0.8,0.2,1.4,0.2c0.4,0,0.7-0.1,1.1-0.2c0.4-0.1,0.7-0.2,0.9-0.3h0.1V35.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSjaelvtestDark);
export default __webpack_public_path__ + "static/media/sjaelvtest_dark.38aaa67f319cd41152b9e320423d8ae5.svg";
export { ForwardRef as ReactComponent };